// extracted by mini-css-extract-plugin
export default {"wrapper":"SlicedText_wrapper__tcP5y","top":"SlicedText_top__KS7Ak","bottom":"SlicedText_bottom__mfbiV"};